export default class GraphsDialogController {
    /** @ngInject */
    constructor(DialogService) {
        this.DialogService = DialogService;
    }

    close() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/graphs/dialogs/save-graphs/controller.js